
import { KpiCardType } from '../types';
import { useToast } from '@/hooks/use-toast';

export const useCardMovement = (
  kpiCards: KpiCardType[], 
  setKpiCards: React.Dispatch<React.SetStateAction<KpiCardType[]>>
) => {
  const { toast } = useToast();

  const moveKpiCard = (id: string, direction: 'left' | 'right' | 'up' | 'down') => {
    const currentIndex = kpiCards.findIndex(card => card.id === id);
    if (currentIndex === -1) return;

    const visibleCards = kpiCards.filter(card => card.visible);
    const currentVisibleIndex = visibleCards.findIndex(card => card.id === id);
    
    let targetVisibleIndex;
    
    switch (direction) {
      case 'left':
        targetVisibleIndex = currentVisibleIndex - 1;
        break;
      case 'right':
        targetVisibleIndex = currentVisibleIndex + 1;
        break;
      case 'up':
        targetVisibleIndex = currentVisibleIndex - 2;
        break;
      case 'down':
        targetVisibleIndex = currentVisibleIndex + 2;
        break;
    }
    
    // Check if the target index is valid
    if (targetVisibleIndex < 0 || targetVisibleIndex >= visibleCards.length) {
      return;
    }
    
    const targetCard = visibleCards[targetVisibleIndex];
    
    // Swap the order of the current card and the target card
    const updatedCards = kpiCards.map(card => {
      if (card.id === id) {
        return { ...card, order: targetCard.order };
      }
      if (card.id === targetCard.id) {
        return { ...card, order: kpiCards[currentIndex].order };
      }
      return card;
    });
    
    // Sort by order
    const sortedCards = [...updatedCards].sort((a, b) => a.order - b.order);
    
    setKpiCards(sortedCards);
    
    toast({
      title: "Card Moved",
      description: `${kpiCards[currentIndex].title} has been moved ${direction}`,
    });
  };

  return { moveKpiCard };
};
